import { styled } from '@mui/material';

export const EligibilityPageWrapper = styled('div')({
  width     : '100%',
  maxWidth  : '560px',
  margin    : '40px auto',
  padding   : '0 18px',
  boxSizing : 'border-box',
});
